<osn-cxb-dialog [style.width]="data?.width ? data.width : 'initial'">
  <h2 *ngIf="data?.title" class="confirm-title mb-3">{{ data.title }}</h2>
  <p *ngIf="data?.description" class="confirm-description mb-4">{{ data.description }}</p>
  <div class="d-flex align-items-center justify-content-center">
    <button class="secondary mr-4" (click)="closeDialog(false)" data-testid="confirm-dialog-cancel-btn">{{ data?.cancelBtnLabel }}</button>
    <button class="confirm-btn" (click)="closeDialog(true)" data-testid="confirm-dialog-confirm-btn">{{ data?.confirmBtnLabel }}</button>
  </div>
</osn-cxb-dialog>
